import { render } from "./ActivityFeedPage.vue?vue&type=template&id=193d69ba"
import script from "./ActivityFeedPage.vue?vue&type=script&lang=js"
export * from "./ActivityFeedPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__